import React from 'react';
import * as Sentry from '@sentry/react';
import {useParams} from 'react-router-dom';
import {Trans, useTranslation} from 'react-i18next';
import {useSummary} from 'context/summary';
import {
  getDocumentType,
  getDocumentNationality,
  useIVStore,
  PhotoBox,
} from '@chekin/shared';
import {useDocumentSelfieDetection} from 'hooks';
import {IV_PHOTO_SOURCE, IV_DOCUMENT_IMAGE_TYPES} from '@chekin/core';
import frontSidePlaceholder from '../../../../assets/img/frontside-placeholder.svg?no-inline';
import {HelperText} from '../styled';

function FrontScanView() {
  const {uploadType} = useParams();
  const {t} = useTranslation();
  const {reservationId, countryCode, data: summary} = useSummary();
  const docType = IV_DOCUMENT_IMAGE_TYPES.front;
  const documentType = useIVStore(getDocumentType);
  const documentNationality = useIVStore(getDocumentNationality);

  const isUpload = uploadType === 'upload';

  const {ProcessModal, ErrorModal, RetryModal, isProcessing, sendFrontSideDocument} =
    useDocumentSelfieDetection({docType});

  const getHelperText = () => {
    if (isUpload) {
      return documentType?.two_sides ? (
        <Trans i18nKey="upload_photo_of_front_side_of_your_document" />
      ) : (
        <Trans i18nKey="upload_photo_of_data_page_of_your_document" />
      );
    } else {
      return documentType?.two_sides ? (
        <Trans i18nKey="first_front_side_of_your_document_expanded" />
      ) : (
        t('place_document_inside_frame')
      );
    }
  };

  const getMobileHelperText = () => {
    return documentType?.two_sides ? (
      <Trans i18nKey="first_front_side_of_your_document_expanded" />
    ) : (
      ''
    );
  };

  const handleChangePhoto = React.useCallback(
    ({image, source}: {image: string; source: IV_PHOTO_SOURCE}) => {
      if (countryCode) {
        sendFrontSideDocument({
          image,
          source,
          countryCode,
          reservationId,
          documentType: documentType?.value,
          nationality: documentNationality,
        });
      } else {
        console.error('countryCode is missing', summary);
        Sentry.captureMessage('countryCode is missing', {extra: {summary}});
      }
    },
    [
      countryCode,
      summary,
      documentType?.value,
      reservationId,
      sendFrontSideDocument,
      documentNationality,
    ],
  );

  return (
    <>
      <HelperText className="iv-front-view__helper">{getHelperText()}</HelperText>

      {!isProcessing && (
        <PhotoBox
          mobileHelperTitle={t('scan_your_document')}
          mobileHelperText={getMobileHelperText()}
          onUploadPhoto={handleChangePhoto}
          preloadedScreenshot={''}
          isUpload={isUpload}
          placeholderImage={frontSidePlaceholder}
        />
      )}

      <ProcessModal />
      <ErrorModal />
      <RetryModal />
    </>
  );
}

export {FrontScanView};
